import React, { useEffect, useState } from 'react';
import ReactTooltip from "react-tooltip";
import { isEmpty } from "lodash";
import Loader from "../../../components/utils/Loader";
import { styles } from "../../../containers/goods/styles";
import { useDispatch, useSelector } from 'react-redux';
import { categoriesRawByType, loaderRawsSelector, selectedRawsByType } from '../../../selectors/raw';
import { fetchProductCategories, fetchRawsList } from '../../../action/raw';
import { fetchFilials } from '../../../action/handbook';
import { fetchGoods, getLastInventory } from '../../../action';
import { fetchSettings } from '../../../action/app';
import DateInput from "../../../components/utils/DateInput";
import swal from "sweetalert";
import { getBalancePoints, getBalanceRaws } from '../../../action/recipes';
import Select from "react-select";
import { MEASURES_RAW } from '../../../containers/rawmaterials/constansts';
import ReactPaginate from 'react-paginate';
import SortButton from '../../../components/utils/SortButton';
import { parseNumToFixed } from '../../../utils/common';

const BalanceList = () => {
    const dispatch = useDispatch();
    const productCategories = useSelector(categoriesRawByType('raw'));
    const raws = useSelector(selectedRawsByType('raw'));
    const loaderList = useSelector(loaderRawsSelector);
    const loadingFilials = useSelector(state => state.loaders.filials);
    const filials = useSelector(state => state.handbook.filials);
    const goods = useSelector(state => state.good.list);
    const settings = useSelector(state => state.settings.init);

    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState(null);
    const [ field, setField ] = useState('id');
    const [ sort, setSort ] = useState('ASC');
    const [ data, setData ] = useState({
        date_lte: new Date(),
        point: null,
        raw: null,
        category: null,
        currentPage: 0,
        _start: 0,
        _limit: 10,
    });

    const [ balance, setBalance ] = useState(null);

    useEffect(() => {
        if (isEmpty(productCategories)) dispatch(fetchProductCategories());
        if (isEmpty(filials)) dispatch(fetchFilials(null, true));
        if (isEmpty(goods)) dispatch(fetchGoods());
        if (isEmpty(settings)) dispatch(fetchSettings());
        if (isEmpty(raws)) dispatch(fetchRawsList());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (data.point || data.raw) onSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [field, sort]);

    const renderPointLabel = (point) => {
        if (!point) return '';
        return `${point.city.name}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    }

    const pointOptions = () => {
        const options = [
            { value: null, label: 'Все филиалы'},
            ...filials.map(el => ({
                value: el.id,
                label: renderPointLabel(el),
                enableConsumption: el.enableConsumption,
            })).sort((a, b) => {
                if (a.label < b.label) return -1;
                if (a.label > b.label) return 1;
                return 0;
            })
        ]
        return options;
    }

    const categoryOptions = () => {
        const options = [
            { value: null, label: 'Все категории'},
            ...productCategories.map(el => ({
                value: el.id,
                label: el.title,
            }))
        ]
        return options;
    }

    const rawMaterialOptions = () => {
        const options = [
            { value: null, label: 'Все сырье'},
            ...raws.map(el => ({
                value: el.id,
                label: el.name,
            }))
        ]
        return options;
    }

    const setPoint = (point) => {
        const updated = {...data};

        if (point && point.value && !point.enableConsumption) { 
            const updated = { ...data, point: null };
            setData(updated);
            return swal({
                title: `Получение данных о ${point.label} невозможно`,
                text: '"Списание сырья" отключено',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });
        };

        updated.point = point.value;
        setData(updated);
    }

    const setFilters = (field, value) => {
        const updated = {...data};
        let dataValue = null;

        if (value && value.value) {
            dataValue = value.value;
        } else {
            dataValue = value;
        }

        updated[field] = dataValue;
        setData(updated);
    }

    const onSearch = async () => {
        let result = null;
        setLoading(true);
        const _sort = `${field}:${sort}`;

        if (data.point) {
            const lastInventory = await dispatch(getLastInventory({id: data.point}));

            if (!lastInventory) return swal({
                title: `Получение данных невозможно`,
                text: 'Нет инвентаризации',
                icon: "error",
                dangerMode: true,
                button: "Ок",
            });

            result = await dispatch(getBalanceRaws({...data, _sort, date_gt: new Date(lastInventory.date)}, lastInventory));
        } else {
            result = await dispatch(getBalancePoints(data));
        }

        if (result && result.error) {
            setLoading(false);
            return setError(result.error.data);
        }

        if (result) {
            setBalance(result);
            setError(null);
            setLoading(false);
        }
    }

    const renderHead = () => {
        return (
            <div className="kt-form kt-form--label-right kt-margin-b-10 d-flex">
                <div className="dateBlock">
                    <DateInput
                        showPopperArrow={false}
                        placeholderText="Дата"
                        selected={data.date_lte}
                        onChange={(date) => setFilters('date_lte', date)}
                    />
                </div>
                <div style={{ width: 200, marginLeft: 10 }}>
                    <Select
                        options={pointOptions()}
                        placeholder="Все филиалы"
                        isLoading={loadingFilials}
                        onChange={(e) => setPoint(e)}
                    />
                </div>
                <div style={{ width: 200, marginLeft: 10 }}>
                    <Select
                        options={categoryOptions()}
                        placeholder="Все категории"
                        isLoading={loaderList}
                        onChange={(e) => setFilters('category', e.value)}
                    />
                </div>
                <div style={{ width: 200, marginLeft: 10 }}>
                    <Select
                        options={rawMaterialOptions()}
                        placeholder="Все сырье"
                        isLoading={loaderList}
                        onChange={(e) => setFilters('raw', e.value)}
                    />
                </div>
                <button
                    style={{ marginLeft: 10 }}
                    onClick={onSearch}
                    className="btn btn-primary"
                    disabled={!data.point && !data.raw}
                >
                    Показать
                </button>
            </div>
        );
    }

    const setPageLimit = (e) => {
        e.preventDefault();
        const updatedPaging = { ...data, _start: 0, _limit: e.target.value, currentPage: 0 };
        setData(updatedPaging);
        onSearch();
    }

    const handlePageClick = (e) => {
        let nextStart =  e.selected * data._limit;
        const updatedPaging = {...data, _start: nextStart, currentPage: e.selected };
        setData(updatedPaging);
        onSearch();
    };

    const chekMarginPagesDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 400) return 1;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        if(userDisplayWidth < 1250) return 4;
        return 6;
    }

    const chekPageRangeDisplayed = () => {
        const userDisplayWidth = window.innerWidth;
        if(userDisplayWidth < 550) return 2;
        if(userDisplayWidth < 850) return 3;
        return 4;
    }

    const renderPagination = () => {
        if (!balance) return;
        const pages = Math.ceil(+balance.count / +data._limit);

        return (
            <div className="kt-datatable__pager kt-datatable--paging-loaded order_table">
                <ReactPaginate
                    previousLabel={<i className="flaticon2-back"></i>}
                    nextLabel={<i className="flaticon2-next"></i>}
                    breakLabel={'...'}
                    breakClassName={'break-me'}
                    pageCount={pages}
                    marginPagesDisplayed={chekMarginPagesDisplayed()}
                    pageRangeDisplayed={chekPageRangeDisplayed()}
                    forcePage={data.currentPage}
                    onPageChange={handlePageClick}
                    containerClassName={'kt-datatable__pager-nav'}
                    subContainerClassName={'pages pagination'}
                    activeClassName={'active'}
                    pageLinkClassName="kt-datatable__pager-link kt-datatable__pager-link-number"
                    previousLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--prev"
                    nextLinkClassName="kt-datatable__pager-link kt-datatable__pager-link--next"
                    activeLinkClassName="kt-datatable__pager-link--active"
                    disabledClassName="kt-datatable__pager-link--disabled"
                />
                    <div className="kt-datatable__pager-info">
                        <div className="kt-datatable__pager-size">
                            <select onChange={setPageLimit} value={data._limit} className="form-control">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="30">30</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            
                        </div>
                        {
                            data._start + data._limit >= balance.count ? (
                                <span className="kt-datatable__pager-detail">Показано {data._start + 1} - {+balance.count} из {balance.count}</span>
                            ) : (
                                <span className="kt-datatable__pager-detail">Показано {data._start + 1} - {+data._start + +data._limit} из {balance.count}</span>
                            )
                        }
                       
                    </div>
            </div>
    
        );
    }

    const handleClickSort = (newFiled) => {
        if (newFiled === field) {
            const newSort = sort === 'DESC' ? 'ASC' : 'DESC';
            setSort(newSort);
        } else {
            setField(newFiled);
            setSort('ASC');
        }
    }

    const renderBody = () => {
        if (loading) return (
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ position: 'relative' }}>
                <table className='kt-datatable__table' style={{ height: '100px'}}>
                    <div style={styles.loading}><Loader /></div>
                </table>
            </div>
        );

        return (
            <div className='kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded' style={{ position: 'relative', marginBottom: '0px' }}>
                <table className='kt-datatable__table'>
                    {balance && <thead className='kt-datatable__head'>
                        <tr className='kt-datatable__row'>
                            <th className='kt-datatable__cell good_id'><SortButton className={field === 'id' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='ID' onClick={() => handleClickSort('id')} up={field === 'id' && sort === 'ASC'}/></th>
                            <th className='kt-datatable__cell' style={{ width: '165px' }}><span>Филиал</span></th>
                            <th className='kt-datatable__cell' style={{ width: '165px' }}><SortButton className={field === 'name' ? 'btn btn-sm btn-primary' : 'btn btn-sm btn-secondary'} text='Наименование' onClick={() => handleClickSort('name')} up={field === 'name' && sort === 'ASC'}/></th>
                            <th className='kt-datatable__cell' style={{ width: 'auto' }}></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Предыдщая инвентаризация</span></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Приход</span></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Расход</span></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Списания</span></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Остатки</span></th>
                            <th className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>Стоимость</span></th>
                        </tr>
                    </thead>}
                    <tbody className='kt-datatable__body'>
                        {!balance
                        ? <tr className='kt-datatable__row'>Нет данных</tr> 
                        : balance.data.map((raw) => {
                            return (
                                <>
                                    <tr className='kt-datatable__row'>
                                        <td className='kt-datatable__cell good_id'>{raw.id || ''}</td>
                                        <td className='kt-datatable__cell' style={{ width: '165px' }}><span>{raw.point ? renderPointLabel(raw.point) : renderPointLabel(filials.find((point) => point.id === data.point))}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '165px' }}><div>{raw.name}</div>{raw.error && <div className='alert fade show alert-outline-danger' style={{ padding: '5px', margin: '0px' }}>{raw.error}</div>}</td>
                                        <td className='kt-datatable__cell' style={{ width: 'auto' }}>{MEASURES_RAW[raw.measure]}</td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{parseNumToFixed(raw.prevInventory, 3) || '-'}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{parseNumToFixed(raw.coming, 3) || 0}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{parseNumToFixed(raw.expenditure, 3) || 0}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span>{parseNumToFixed(raw.writeoff, 3) || 0}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span style={raw.balance < 0 ? { color: 'red' } : {}}>{parseNumToFixed(raw.balance, 3) || 0}</span></td>
                                        <td className='kt-datatable__cell' style={{ width: '140px', textAlign: 'center' }}><span style={raw.sum < 0 ? { color: 'red' } : {}}>{parseNumToFixed(raw.sum, 3) || 0}</span></td>
                                    </tr>   
                                </>
                            );
                        })
                        }
                    </tbody>
                </table>
                {renderPagination()}
            </div>
        );
    }

    return (
        <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid" style={{ padding: 0 }} >
                <div className="kt-portlet__body">
                {renderHead()}
                {data.error && 
                    <div className='alert fade show alert-outline-danger'>
                        <div className="alert-icon"><i className="flaticon-warning"></i></div>
                        <div className="alert-text">{`Ошибка ${error.statusCode} ${data.message}`}</div>
                    </div>
                }
                {renderBody()}
            </div>
            <ReactTooltip
                effect="solid"
                type="dark"
                place="top"
            />
        </div>
    );
};

export default BalanceList;
